module.exports = __webpack_public_path__ + "static/media/settings.a0b9f768.svg";